import { ACCOUNT_LIST_ROW_CLASS } from '@/components/account/AccountListRow';
import { Divider } from '@/components/ui/divider';
import { HStack } from '@/components/ui/hstack';
import { Switch } from '@/components/ui/switch';
import { Text } from '@/components/ui/text';
import { VStack } from '@/components/ui/vstack';
import { useColors } from '@/hooks/useColors';

/**
 * A switch laid out as an account list row: the same height, type and closing divider as the
 * rows around it, so the section reads as one list.
 */
export function AccountSwitchRow({
  title,
  subtitle,
  value,
  disabled,
  onValueChange,
}: {
  title: string;
  subtitle: string;
  value: boolean;
  disabled?: boolean;
  onValueChange: (value: boolean) => void;
}) {
  const { colors } = useColors();

  return (
    <VStack className={ACCOUNT_LIST_ROW_CLASS}>
      <HStack className="w-full items-center justify-between gap-4">
        <VStack className="min-w-0 flex-1">
          <Text>{title}</Text>

          <Text size="sm" className="text-typography-600">
            {subtitle}
          </Text>
        </VStack>

        <Switch
          accessibilityLabel={title}
          trackColor={{ true: colors.secondary[500], false: colors.background[200] }}
          value={value}
          disabled={disabled}
          onValueChange={onValueChange}
        />
      </HStack>

      <Divider />
    </VStack>
  );
}
